import { useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { KeyRound } from "lucide-react";

export default function ChangePassword() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (newPassword.length < 8) {
      setError("Das neue Passwort muss mindestens 8 Zeichen haben");
      return;
    }
    if (newPassword !== confirm) {
      setError("Die neuen Passwörter stimmen nicht überein");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success("Passwort gesetzt — willkommen!");
      window.location.href = "/";
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="change-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm border border-amber-500/40 bg-amber-500/10 mb-4">
            <KeyRound className="text-amber-400" size={22} strokeWidth={1.5} />
          </div>
          <div className="font-display text-2xl font-extrabold tracking-tight text-slate-100">
            Neues Passwort erforderlich
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mt-2">
            Erste Anmeldung · {user?.email}
          </div>
        </div>

        <form onSubmit={submit} className="panel p-6 space-y-4" data-testid="change-password-form">
          <p className="text-xs text-slate-300 leading-relaxed">
            Dein Konto wurde mit einem Start-Passwort angelegt. Bitte vergib jetzt ein eigenes Passwort —
            der Rest der Plattform ist bis dahin gesperrt.
          </p>
          <div>
            <label className="mono-label block mb-1.5" htmlFor="current-password">Aktuelles Passwort</label>
            <input
              id="current-password"
              type="password"
              required
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="input-dark"
              data-testid="current-password-input"
            />
          </div>
          <div>
            <label className="mono-label block mb-1.5" htmlFor="new-password">Neues Passwort</label>
            <input
              id="new-password"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="input-dark"
              data-testid="new-password-input"
            />
          </div>
          <div>
            <label className="mono-label block mb-1.5" htmlFor="confirm-password">Neues Passwort bestätigen</label>
            <input
              id="confirm-password"
              type="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="input-dark"
              data-testid="confirm-password-input"
            />
          </div>
          {error ? (
            <div className="border border-red-500/40 bg-red-500/10 text-red-300 text-xs font-mono px-3 py-2 rounded-sm" data-testid="change-password-error">
              {error}
            </div>
          ) : null}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="change-password-submit-button">
            {busy ? "Setze Passwort…" : "Passwort setzen & weiter"}
          </button>
        </form>
      </div>
    </div>
  );
}
